import React from 'react';

export type NativeInputProps = React.InputHTMLAttributes<HTMLInputElement>;

/** Thin, unstyled passthrough wrapper around a native `<input>` element. */
export const NativeInput = React.forwardRef<HTMLInputElement, NativeInputProps>(
  (props, ref) => <input ref={ref} {...props} />
);

NativeInput.displayName = 'NativeInput';
